module.exports = __webpack_public_path__ + "media/src/img/slider-arrow-3e1e6f28e0c5c84a816804068580d23d.svg";